import React, { useEffect, useState, useMemo } from "react";
import { useSelector } from "react-redux";
import Tables from "../../../../components/Tables";
import { getDateChangeTime } from "../../../../../helper/helper";
import { TYPE_GET_DATE } from "../../../../../helper/const";
import FilterTimeDate from "../../../components/FilterTimeDate";
import styled from "styled-components";

export default function Details({ handleGetData, tabActive, isMissCall = false }) {
  const [date, setDate] = useState(getDateChangeTime(TYPE_GET_DATE.now));
  const { result = {} } =
      useSelector((state) => state.reducerNatcom?.data) || {};
    const { data: airtime } = result;

  useEffect(() => {
    if (tabActive !== "2") return;
    handleGetData(date, date);
  }, [date, tabActive, handleGetData]);

  // Transform airtime data for the selected date into table format
  const columns = useMemo(() => {
    if (!airtime || typeof airtime !== 'object' || !airtime[date]) {
      return {
        dataKey: [],
        defineData: [],
      };
    }

    const dayData = airtime[date];
    if (!Array.isArray(dayData)) {
      return {
        dataKey: [],
        defineData: [],
      };
    }

    // Define table columns
    const dataKey = [
      {
        title: "Hour",
        dataIndex: "hour",
        key: "hour",
        width: 100,
        fixed: "left",
      },
      {
        title: "Check Sub Error",
        dataIndex: "check_sub_error",
        key: "check_sub_error",
        width: 150,
        render: (value) => value?.toLocaleString() || 0,
      },
      {
        title: "Not Enough Money",
        dataIndex: "not_enough_money",
        key: "not_enough_money",
        width: 150,
        render: (value) => value?.toLocaleString() || 0,
      },
      {
        title: "Cancel",
        dataIndex: "cancel",
        key: "cancel",
        width: 120,
        render: (value) => value?.toLocaleString() || 0,
      },
      {
        title: "Call Invalid",
        dataIndex: "call_invalid",
        key: "call_invalid",
        width: 120,
        render: (value) => value?.toLocaleString() || 0,
      },
      {
        title: "Total",
        dataIndex: "total",
        key: "total",
        width: 150,
        render: (value) => value?.toLocaleString() || 0,
      },
    ];

    // Transform data for table display
    const defineData = dayData.map((item, index) => ({
      key: `${item.hour || index}`,
      hour: item.hour === "allday" ? "ALL DAY" : (item.hour || "Unknown"),
      check_sub_error: item.check_sub_error || 0,
      not_enough_money: item.not_enough_money || 0,
      cancel: item.cancel || 0,
      call_invalid: item.call_invalid || 0,
      total: item.total || 0,
    }));

    return {
      dataKey,
      defineData,
    };
  }, [airtime, date]);

  return (
    <Container>
      <div
        className="position-relative d-flex justify-right mb-2"
        style={{ justifyContent: "right" }}
      >
        <FilterTimeDate date={date} setDate={setDate} />
      </div>
      <Tables
        columns={columns}
        title={`Details Table`}
        isHiddenPagination={false}
      />
    </Container>
  );
}

const Container = styled.div`
  .panel-sortable {
    tr:last-child {
      td {
        font-weight: 600;
      }
    }
  }
`;
